<template>
  <el-table
    :data="papers"
    stripe
    style="width: 100%">

    <el-table-column
      prop="name"
      label="Paper name">
        <template slot-scope="scope">
          <a :href="'/archives/'+scope.row.name"
            class="buttonText">{{scope.row.name}}</a>
        </template>
    </el-table-column>
        
    <el-table-column
      prop="author"
      label="Author"
      width="250">
    </el-table-column>

    <el-table-column
      prop="create_time"
      label="Post Time"
      width="200">
    </el-table-column>
    <el-table-column
      prop="edit_time"
      label="Edit Time"
      width="200">
    </el-table-column>
  </el-table>
</template>

<script>
    import util from '../libs/util.js';

    export default {
        data() {
            return {
                query: {
                    query: '',
                    size: 15,
                    page: 1
                },
                columns: [
                   {
                        title: 'paper name',
                        key: 'name',
                        //width: 550 
                    },
                    {
                        title: 'Author',
                        key: 'author',
                        width: 250
                    },

                    {
                        title: 'Post Time',
                        key: 'create_time',
                        width: 150
                    },
 
                    {
                        title: 'Edit Time',
                        key: 'edit_time',
                        width: 150
                    },
                  
                    
                ],
                total: 0,
                papers: []
            };
        },
       methods: {
            queryHosts() {
                //this.$Loading.start();
                util.ajax
                    //.get('/papers/lists', {params: this.query})
                    .get('/archives/lists', {params: this.query})
                    .then(response => {
                        //this.$Loading.finish();
                        console.log(response);
                        
/*
                        for (let paper of response.data.papers) {
                            //paper.name = "<a href='#'>" + paper.name + "</a>";
                            //host.online = host.online ? '是' : '否';
                            //host.uptime = convertSecsToTime(host.uptime);
                            //paper.time = paper.time;
                            //host.cpu_usage = host.cpu_usage.toFixed(2) + '%';
                            //host.memory_usage = host.memory_usage.toFixed(2) + '%';
                        }
                        */


                        this.total = response.data.paper_total;
                        this.papers = response.data.papers;
                    })
                    .catch(error => {
                        this.$Loading.error();
                        this.$Notice.error({
                            title: '查询失败1',
                            desc: error.response ? error.response.data.error : error,
                            duration: 2
                        });
                    });
            },
            changePage(n) {
                this.query.page = n;
                this.queryHosts();
            },
            changePageSize(n) {
                this.query.size = n;
                this.queryHosts();
            },
            queryHost(uuid) {
                this.$router.push({name: 'host_detail', params: {uuid}});
            }
        },
        mounted() {
            this.queryHosts();
        }
    };
</script>

<style scoped>
/*
    .query-input {
        width: 500px;
    }

    .paging {
        padding: 15px 0 0 0;
    }

    .total {
        float: left;
        font-size: 14px;
    }

    .page {
        float: right;
    }
    */
</style>

